module.exports = __webpack_public_path__ + "img/02_tu.17fc38e6.png";